export function StarDivider({ label, className = "" }) {
  return (
    <div className={`star-divider ${className}`}>
      <span className="text-[var(--gold)]">★</span>
      {label && <span className="heading text-lg tracking-widest whitespace-nowrap gold-text">{label}</span>}
      <span className="text-[var(--gold)]">★</span>
    </div>
  );
}

export function Panel({ children, className = "", gold = false, testid }) {
  return (
    <div data-testid={testid} className={`panel clip-beveled ${gold ? "panel-gold" : ""} ${className}`}>
      {children}
    </div>
  );
}

export function StatCard({ icon: Icon, value, label, testid }) {
  return (
    <Panel testid={testid} className="p-5 group transition-colors hover:panel-gold">
      <div className="flex items-center gap-4">
        <Icon className="w-8 h-8 text-[var(--gold)] group-hover:drop-shadow-[0_0_8px_rgba(201,162,39,0.6)]" strokeWidth={1.5} />
        <div>
          <div className="font-oswald text-3xl font-bold text-white leading-none">{value}</div>
          <div className="font-rajdhani text-xs text-[var(--silver)] uppercase tracking-widest mt-1">{label}</div>
        </div>
      </div>
    </Panel>
  );
}

export function PageTitle({ title, subtitle, action }) {
  return (
    <div className="flex items-end justify-between mb-6 flex-wrap gap-4">
      <div>
        <h1 className="heading text-4xl sm:text-5xl gold-text" data-testid="page-title">{title}</h1>
        {subtitle && <p className="font-rajdhani text-sm text-[var(--silver)] uppercase tracking-widest mt-1">{subtitle}</p>}
      </div>
      {action}
    </div>
  );
}

const STATE_LABELS = {
  draft: "Bozza", registration_open: "Iscrizioni Aperte", registration_closed: "Iscrizioni Chiuse",
  lobby_generated: "Lobby Generate",
  in_progress: "In Corso", completed: "Completato", archived: "Archiviato",
};

export function StateBadge({ state }) {
  const active = state === "in_progress";
  return (
    <span className={`inline-block px-3 py-1 font-rajdhani font-bold uppercase text-xs tracking-wider clip-beveled-sm ${active ? "bg-[var(--gold)] text-black" : "bg-[#1a1a1a] text-[var(--gold)] border border-[var(--gold)]/50"}`}>
      {STATE_LABELS[state] || state}
    </span>
  );
}

const TYPE_LABELS = { SAF: "Torneo SAF", INTERNAL_SEALS: "Torneo interno Seals" };

export function TypeBadge({ type }) {
  const saf = type === "SAF";
  return (
    <span data-testid="type-badge" className={`inline-block px-2.5 py-0.5 font-rajdhani font-bold uppercase text-[10px] tracking-wider clip-beveled-sm ${saf ? "bg-[#22d3ee]/15 text-[#22d3ee] border border-[#22d3ee]/40" : "bg-[#a78bfa]/15 text-[#a78bfa] border border-[#a78bfa]/40"}`}>
      {TYPE_LABELS[type] || type || "SAF"}
    </span>
  );
}

export { STATE_LABELS, TYPE_LABELS };
